import axios from "axios";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const { REACT_APP_API_KEY } = process.env || {};

const useGetAllTemplate = () => {
  const navigate = useNavigate();
  const [allTemplate, setAllTemplate] = useState([]);
  const [isTemplateLoading, setIsTemplateLoading] = useState(true);

  const getAllTemplate = useCallback(
    async (inputValue = "") => {
      const token = localStorage.getItem("authToken");
      try {
        const res = await axios.get(
          `/api/v1/template`,
          {
            params: { query: inputValue },
            headers: {
              Authorization: `Bearer ${token}`,
              "ngrok-skip-browser-warning": "hgs",
            },
          }
        );
        setAllTemplate(res.data);
        setIsTemplateLoading(false);
      } catch (error) {
        console.error(error, "error");
        const errorMessage = error.response?.data?.message;
        if (!error.response) {
          toast.error("Oops, something went wrong");
        } else {
          const messageContent = Array.isArray(errorMessage) ? (
            <ul className="ms-2 list-disc">
              {errorMessage.map((msg, index) => (
                <li key={index}>{msg}</li>
              ))}
            </ul>
          ) : (
            errorMessage || "An unknown error occurred"
          );
          toast.error(messageContent);
          if (error.response?.data?.statusCode === 401) {
            localStorage.removeItem("authToken");
            setTimeout(() => {
              navigate("/");
            }, 1000);
          }
        }
      } finally {
        setIsTemplateLoading(false);
      }
    },
    [navigate]
  );

  return {
    allTemplate,
    isTemplateLoading,
    getAllTemplate,
  };
};

export default useGetAllTemplate;
